import { Component, OnInit, ViewChild, Inject } from '@angular/core';

import {
  MatPaginator, MatTableDataSource,
  MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar, MatDatepickerInputEvent
} from '@angular/material';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import { DataSource } from '@angular/cdk/collections';
import { ProductserialnoService } from '../../../services/productserialno/productserialno.service';
import { OrderService } from '../../../services/order/order.service';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/compiler/src/core';
import { Address } from '../../../interfaces/address';
import { Router } from '@angular/router';
import { getLocaleDateFormat } from '@angular/common';
import { serializePath } from '@angular/router/src/url_tree';
import { TokenStorage } from 'src/app/auth/token.storage';
import { BranchService } from 'src/app/services/branch/branch.service';
import { NotifierService } from 'angular-notifier';


@Component({
  selector: 'app-orderdetailsandeditorder',
  templateUrl: './orderdetailsandeditorder.component.html',
  styleUrls: ['./orderdetailsandeditorder.component.scss']
})
export class OrderDetailsAndEditOrderComponent implements OnInit {
  columnsToDisplay = [
    'productDetails',
    'requiredQty',
  ];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  orderId: number;
  receiverName: string;
  orderState: string;
  public availableQtyInStore = [];
  invoiceNumber: string;
  orderCreatedTimestamp: string;
  deliveryDatetime: string;
  totalweightCapacity: number;
  totalvolumeCapacity: number;
  dispatchDate: string;
  houseNumber: string;
  area: string;
  city: string;
  pincode: string;
  zone: string;
  zoom: number = 13;
  lat: number = 18.533989;
  lng: number = 73.825592;
  order: any;
  orderDataArray = new MatTableDataSource;
  orderNumber: string;
  ordersByTripIdArray = [];
  productArrayInSelectedOrder = [];
  productInputDisplayArray = [];
  public receiverAddress: Address;
  public originAddress: Address;
  remarksInput: string;
  minDate: Date;
  public selectedOrdersDataArray = [];
  public countSerialNnumberPerStore;
  showMessage: boolean = false;
  totalProd: number = 0;
  isZoneOfOriginAddress: boolean = false;
  allBranchesNames = [];
  isBranchChanged: boolean = false;
  branch;
  isBajaj: boolean = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public productserialnoService: ProductserialnoService,
    public orderService: OrderService,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    public router: Router,
    private token: TokenStorage,
    private branchService: BranchService,
    private notifierService: NotifierService
  ) {
    if (this.token.getTenant() == 'bajaj-reta-test' || this.token.getTenant() == 'bajaj-reta-prod') {
      this.isBajaj = true;
    }
    console.log(data)
    this.order = this.data.data;

  }

  ngOnInit() {
    if (this.token.getTenant() === 'bajaj-reta-prod' || this.token.getTenant() === 'bajaj-reta-test')
      this.isZoneOfOriginAddress = true;
    console.log(this.order);
    this.orderId = this.order.orderInfo.orderUniqueId;
    this.receiverName = this.order.orderInfo.receiverName;
    this.receiverAddress = this.order.orderInfo.destinationAddress;
    this.originAddress = this.order.orderInfo.originAddress;
    if (this.isZoneOfOriginAddress)
      this.zone = this.order.orderInfo.originAddress.zone;
    else
      this.zone = this.order.orderInfo.destinationAddress.zone;
    this.orderState = (this.order.orderInfo.oState).slice(12);
    this.invoiceNumber = this.order.orderInfo.orderInvoiceNumber;
    this.originAddress = this.order.orderInfo.originAddress;
    this.orderCreatedTimestamp = this.order.orderInfo.orderCreatedDateTime;
    this.deliveryDatetime = this.order.orderInfo.deliveryETADateTime;
    this.totalvolumeCapacity = this.order.orderInfo.totalVolume;
    this.totalweightCapacity = this.order.orderInfo.totalWeight;
    this.dispatchDate = this.order.orderInfo.deliveryETADateTime;
    // this.orderDataArray.data = [this.order];
    console.log(this.orderDataArray.data);
    this.minDate = new Date();
    this.branch = this.order.orderInfo.branchName;
    this.getAllProductsFromOrdersInTrip();
    if (this.isBajaj) {
      this.branchService.getAllBranches().subscribe(allBranches => {
        this.allBranchesNames = allBranches;
        this.allBranchesNames.sort(function (a, b) {
          let branchArea1 = a.branchName.toLowerCase(), branchArea2 = b.branchName.toLowerCase()
          if (branchArea1 < branchArea2)
            return -1
          if (branchArea1 > branchArea2)
            return 1
          return 0
        });
      });
    }
  }


  changeState() {
    console.log('order' + this.order.orderInfo.orderUniqueId);

    console.log(this.order);
    this.order.orderInfo.oState = "ORDER_STATE_UNPLANNED";
    this.orderService.orderStateChange(this.order.orderInfo.orderUniqueId, this.order.orderInfo.oState).subscribe(res => {
      console.log(res);
      this.router.navigate(['/scheduling/createtrips']);
    }, Error => {
      console.log(Error);
    });
  }

  getAllProductsFromOrdersInTrip() {
    this.orderService.getAllProductsInOrder(this.orderId).subscribe(res => {
      for (let i = 0; i < res.length; i++) {
        this.productArrayInSelectedOrder.push({
          productId: res[i].product.productId,
          productdetails: res[i].product.productName,
          productQuantity: res[i].productQuantity,
        });
        this.orderDataArray.data = this.productArrayInSelectedOrder;
      }
      //this.showmessage();
    }, Error => {
      console.log(Error);
    })
  }

  showOrderReadyToMoveToUnplanned() {
    let findProductWithZeroQuantity = this.productArrayInSelectedOrder.find(fp => fp.availableProductQuantity == 0 || fp.productQuantity == 0 || fp.availableProductQuantity < fp.productQuantity);
    console.log("findprod", findProductWithZeroQuantity)
    if (!findProductWithZeroQuantity) {
      this.showMessage = true;
    }

  }

  prepareToSend(orderchecked, Event) {
    let productId = orderchecked.productId;
    let productList = this.order.prodQList;

    let foundProductFromOrder = productList.find(pl => pl.product.productId === productId);
    console.log(orderchecked);

    if (Event.checked) {
      foundProductFromOrder.bMarkForDelivery = true;
    } else {
      foundProductFromOrder.bMarkForDelivery = false;
    }

    console.log(foundProductFromOrder);
  }
  submitAction() {
    console.log(this.order);
    this.orderService.prepareOrderForDelivery(this.order).subscribe(result => {
      console.log(result);
      let message = "Updated Delivery";
      this.openSnackBar(message);
    });
  }


  openSnackBar(message) {
    this.snackBar.open(message, 'ok', {
      duration: 2000
    })
  }

  changeBranch(event) {
    if (this.branch == event.srcElement.value) {
      this.isBranchChanged = false
    }
    else {
      this.isBranchChanged = true;
      this.order.orderInfo.branchName = event.srcElement.value;
    }
  }

  orderUpdate() {
    delete this.order.isChecked;
    this.orderService.orderUpdate(this.order).subscribe(orderupdated => {
      console.log(orderupdated);
      this.notifierService.notify("success", "Branch Changed Successfully.")
    }, Error => {
      this.notifierService.notify("error", "Error In Changing Branch.")
      console.log(Error);
    })
  }
}




